// @ts-nocheck
/**
 * GeChiUI dependencies
 */
import { createContext } from '@gechiui/element';
import warning from '@gechiui/warning';

const SlotFillContext = createContext( {
	slots: {},
	fills: {},
	registerSlot: () => {
		warning(
			'Components must be wrapped within `SlotFillProvider`. ' +
				'See https://developer.gechiui.com/block-editor/components/slot-fill/'
		);
	},
	updateSlot: () => {},
	unregisterSlot: () => {},
	registerFill: () => {},
	unregisterFill: () => {},
} );

export default SlotFillContext;
